module.exports = __webpack_public_path__ + "ProximaNova-LightIt.563949f22632f50eebf6f5da2ff7e24c.woff";